<div class="tw-h-svh tw-flex tw-justify-center tw-items-center">
  <div class="tw-max-w-screen-sm tw-m-auto">
    <p class="tw-text-2xl tw-font-semibold">You are not authorized!</p>
    <p class="mb-3 tw-text-gray-500">
      It seems like you don't have permission to access the requested page. Please contact your administrator.
    </p>
    <a routerLink="/redirect" class="text-link text-primary">Go Back</a>
  </div>
</div>
